module.exports = __webpack_public_path__ + "static/media/VIDEO-COUNT-3.b33dc78d.png";